import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  AbsenceFormComponent,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'app-absence-overview',
  templateUrl: './absence-overview.component.html',
  styleUrls: ['./absence-overview.component.scss'],
  standalone: false,
})
export class AbsenceOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalCtrl: ModalController,
    public toolService: ToolService
  ) {}

  selectedUser: string;

  ngOnInit() {}

  handleRefresh(event: any) {
    this.state.loadAbsenceEntries().subscribe((x) => {
      event.target.complete();
    });
  }

  async openAbsenceFormModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: AbsenceFormComponent,
      componentProps: {
        absenceEntryId: id,
        selectedUsers: [this.selectedUser],
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }
}
